import { getBackendUrl } from './api.js';
import { authState } from './auth.js';
import { createSSEConnection } from './sse.js';

/**
 * Creates an SSE connection for commission real-time updates.
 * Wraps the generic kit SSE connection with commission-specific URL building
 * and auto-reconnect using a fresh auth token.
 *
 * @param {string} commissionId
 * @param {(event: { commissionId: string, eventType: string }) => void} onEvent
 * @returns {{ connect: () => Promise<void>, disconnect: () => void }}
 */
export function createCommissionSSE(commissionId, onEvent) {
    let reconnectTimer = null;

    const sse = createSSEConnection(`${getBackendUrl()}/api/commissions/${commissionId}/events`, {
        onEvent,
        onError: () => {
            sse.disconnect();
            // Auto-reconnect after 3 seconds with a fresh token
            reconnectTimer = setTimeout(() => connect(), 3000);
        },
    });

    async function connect() {
        clearReconnectTimer();
        let token;
        try {
            token = await authState.getAccessToken();
        } catch {
            return;
        }
        sse.connect(token);
    }

    function disconnect() {
        clearReconnectTimer();
        sse.disconnect();
    }

    function clearReconnectTimer() {
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
        }
    }

    return { connect, disconnect };
}
